export type MarkerShapeType = 'circle' | 'square' | 'triangle' | 'diamond';

export interface MarkerShapeProps {
  type: MarkerShapeType;
  size: number;
  fill: string;
  fillOpacity: number;
  stroke: string;
  strokeWidth: number;
  strokeOpacity: number;
  dashArray?: string;
  opacity?: number;
}

export default function MarkerShape({
  type,
  size,
  fill,
  fillOpacity,
  stroke,
  strokeWidth,
  strokeOpacity,
  dashArray,
  opacity = 1,
}: MarkerShapeProps) {
  const inset = strokeWidth / 2;
  const far = size - inset;
  const mid = size / 2;
  const paint = {
    fill,
    fillOpacity,
    stroke: strokeWidth > 0 ? stroke : 'none',
    strokeWidth,
    strokeOpacity,
    strokeDasharray: dashArray,
  };

  let shape;
  switch (type) {
    case 'square':
      shape = <rect x={inset} y={inset} width={size - strokeWidth} height={size - strokeWidth} {...paint} />;
      break;
    case 'triangle':
      shape = <polygon points={`${mid},${inset} ${far},${far} ${inset},${far}`} {...paint} />;
      break;
    case 'diamond':
      shape = <polygon points={`${mid},${inset} ${far},${mid} ${mid},${far} ${inset},${mid}`} {...paint} />;
      break;
    default:
      shape = <circle cx={mid} cy={mid} r={(size - strokeWidth) / 2} {...paint} />;
  }

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ display: 'block', opacity }} aria-hidden="true">
      {shape}
    </svg>
  );
}
